import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navbar.module.css';

export default function Navbar({ user, dbUser, onSignOut }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const isAdmin = !!dbUser?.isAdmin;
  const isApprover = !!dbUser?.isApprover; // includes Admin
  const canViewReports = !!dbUser?.canViewReports; // Reports or Admin
  const hasManagement = isAdmin || isApprover || canViewReports;

  return (
    <nav className={styles.nav}>
      <div className={styles.brand}>
        <img src={process.env.PUBLIC_URL + '/logo-hesed-top.png'} alt="גמ״ח חסד בלוד" />
      </div>

      <button className={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)} aria-label="תפריט">
        <span className={`${styles.bar} ${menuOpen ? styles.barOpen : ''}`} />
        <span className={`${styles.bar} ${menuOpen ? styles.barOpen : ''}`} />
        <span className={`${styles.bar} ${menuOpen ? styles.barOpen : ''}`} />
      </button>

      <div className={`${styles.menu} ${menuOpen ? styles.menuOpen : ''}`}>
        <div className={styles.links}>
          {/* אזור אישי */}
          <NavLink to="/requests" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
            בקשה חדשה
          </NavLink>
          <NavLink to="/my-history" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
            הבקשות שלי
          </NavLink>
          <NavLink to="/bank-accounts" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
            חשבונות הבנק שלי
          </NavLink>

          {/* הפרדה — ניהול */}
          {hasManagement && <div className={styles.separator} />}

          {isApprover && (
            <NavLink to="/approve" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              אישור בקשות
            </NavLink>
          )}
          {isApprover && (
            <NavLink to="/history" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              כל הבקשות
            </NavLink>
          )}
          {isApprover && (
            <NavLink to="/pdf-exports" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              אישורים לבנק
            </NavLink>
          )}
          {isApprover && (
            <NavLink to="/money-fund" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              קרן כספית
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/unpaid-checks" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              צ'קים שטרם נפרעו
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/import" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              תנועות בנק
            </NavLink>
          )}
          {canViewReports && (
            <NavLink to="/donations" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              תרומות
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin/users" className={({ isActive }) => isActive ? styles.active : ''} onClick={() => setMenuOpen(false)}>
              משתמשים
            </NavLink>
          )}
        </div>

        <div className={styles.user}>
          <img src={user.picture} alt={user.name} className={styles.avatar} />
          <span>{user.name}</span>
          <button onClick={onSignOut} className={styles.signOut}>התנתק</button>
        </div>
      </div>
    </nav>
  );
}
